import React, { useEffect, useState } from "react";
import { Select, SelectItem, TextInput, Button, Checkbox } from "@wfp/ui";
import ReactSelect from "react-select";
import { iconFilterAlt, iconRestartGlyph } from "@wfp/icons";
import { selectContainerStyles } from "SCConstants";

import "./Filtering.scss";
import { FormattedMessage } from "react-intl";

const Filtering = (props) => {
  const { showClear = true } = props;
  const { showSecondaryButton = false } = props;
  const [state, setState] = useState(props.defaults || {});
  useEffect(() => {
    setState(props.defaults ? props.defaults : {});
  }, [props.defaults]);

  const setFieldValue = (id, value) => {
    let nextState;
    setState((prev) => {
      const next = { ...prev };
      if (!value) delete next[id];
      else next[id] = value;
      const resets = props.controlledResets?.[id];
      if (resets) resets.forEach((field) => delete next[field]);
      nextState = next;
      return next;
    });
    if (props.onFieldChange) props.onFieldChange(id, value, nextState);
    if (
      props.onSubmit &&
      Array.isArray(props.autoSubmitFields) &&
      props.autoSubmitFields.includes(id)
    ) {
      props.onSubmit(nextState);
    }
  };

  const onChange = (e) => {
    e.persist();
    const value = e.target.value;
    const id = e.target.id;
    setFieldValue(id, value);
  };

  const submit = (e) => {
    e.stopPropagation();
    e.preventDefault();
    props.onSubmit(state);
  };

  const secondarySubmit = (e) => {
    e.stopPropagation();
    e.preventDefault();
    if (props.secondaryButton.secondaryButtonState.selectedAllState === false) {
      props.secondaryButton.onSubmit(state);
      props.secondaryButton.secondaryButtonState.setSelectedAll(true);
    } else {
      clear();
      props.secondaryButton.secondaryButtonState.setSelectedAll(false);
      const selectionRef =
        props.secondaryButton.selectedSchoolsIds ||
        props.secondaryButton.selectedVendorsIds;
      if (selectionRef) {
        selectionRef.current = {};
      }
    }
  };
  const clear = () => {
    setState({});
    props.onSubmit({});
  };
  return (
    <form className="filtering" onSubmit={submit}>
      {props?.fields?.map(
        ({
          name,
          label,
          type = "text",
          options,
          disabled,
          visibleWhen,
          newRow,
          className,
        }) => {
          if (visibleWhen && !visibleWhen(state)) return null;
          const filterProps = {
            onChange,
            id: name,
            key: name,
            labelText: label,
            value: state[name] || "",
            disabled,
          };
          const element = (() => {
            switch (type) {
              case "select":
                return (
                  <Select {...filterProps}>
                    {options?.map(({ name, label }) => (
                      <SelectItem key={name} value={name} text={label} />
                    ))}
                  </Select>
                );
              case "checkbox":
                return (
                  <Checkbox
                    id={name}
                    key={name}
                    labelText={label}
                    checked={state[name] || false}
                    onChange={(e) => {
                      setState({ ...state, [name]: e.target.checked });
                    }}
                  />
                );
              case "autocomplete": {
                const selectedOption =
                  options?.find(
                    (option) =>
                      String(option.value) === String(state[name] || "")
                  ) || null;

                return (
                  <div
                    key={name}
                    className={`filter-autocomplete${
                      className ? ` ${className}` : ""
                    }`}
                  >
                    <label
                      className="wfp--label"
                      style={{
                        opacity: disabled ? "0.5" : "",
                      }}
                    >
                      {label}
                    </label>
                    <ReactSelect
                      styles={selectContainerStyles.valid}
                      className="react-select-container"
                      classNamePrefix="react-select"
                      options={options}
                      isDisabled={disabled}
                      isClearable
                      value={selectedOption}
                      onChange={(selected) => {
                        const selectedValue = selected
                          ? String(selected.value)
                          : "";
                        setFieldValue(name, selectedValue);
                      }}
                    />
                  </div>
                );
              }
              case "multiselect": {
                const selectedValues = String(state[name] || "")
                  .split(",")
                  .map((value) => value.trim())
                  .filter(Boolean);

                const selectOptions = (options || []).map((option) => ({
                  value: String(option.name),
                  label: option.label,
                }));

                const selectedOptions = selectOptions.filter((option) =>
                  selectedValues.includes(option.value)
                );

                return (
                  <div
                    key={name}
                    className={`filter-autocomplete${
                      className ? ` ${className}` : ""
                    }`}
                  >
                    <label
                      className="wfp--label"
                      style={{
                        opacity: disabled ? "0.5" : "",
                      }}
                    >
                      {label}
                    </label>
                    <ReactSelect
                      styles={selectContainerStyles.valid}
                      className="react-select-container"
                      classNamePrefix="react-select"
                      options={selectOptions}
                      isMulti
                      closeMenuOnSelect={false}
                      isDisabled={disabled}
                      value={selectedOptions}
                      onChange={(selected) => {
                        const selectedValue = Array.isArray(selected)
                          ? selected
                              .map((item) => String(item.value))
                              .filter(Boolean)
                              .join(",")
                          : "";
                        setFieldValue(name, selectedValue);
                      }}
                    />
                  </div>
                );
              }
              default:
                return <TextInput {...filterProps} />;
            }
          })();
          if (newRow) {
            return (
              <React.Fragment key={name}>
                <div className="filter-row-break" />
                {element}
              </React.Fragment>
            );
          }
          return element;
        }
      )}
      <div
        className={`filter-buttons${
          props.buttonsNewRow ? " filter-buttons--new-row" : ""
        }`}
      >
        <Button
          icon={iconFilterAlt}
          type="button"
          onClick={submit}
          kind="secondary"
        >
          {
            <FormattedMessage
              id="CountryAdmin.filter"
              defaultMessage="Filter"
            />
          }
        </Button>
        {showClear && (
          <Button
            icon={iconRestartGlyph}
            type="button"
            onClick={clear}
            kind="tertiary"
          >
            {
              <FormattedMessage
                id="CountryAdmin.clear"
                defaultMessage="Clear"
              />
            }
          </Button>
        )}
        {showSecondaryButton && (
          <Button
            type="button"
            onClick={(e) => {
              secondarySubmit(e);
            }}
            kind="secondary"
          >
            {props.secondaryButton.secondaryButtonState.selectedAllState ===
            true
              ? props.secondaryButton?.secondaryName
              : props.secondaryButton?.name}
          </Button>
        )}
      </div>
    </form>
  );
};

export default Filtering;
